import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';

import logger from '@/infra/logger';

export default async function () {
  try {
    await FirebaseAnalytics.initializeFirebase({
      apiKey: 'AIzaSyDfEH9Fij72r_F8lMlwMRpKnNJF_PtC604',
      projectId: 'beconfident-app',
      storageBucket: 'beconfident-app.appspot.com',
      messagingSenderId: '1044640802602',
      appId: '1:1044640802602:web:196e9f85ba3d4d5dc46053',
      authDomain: 'beconfident-app.firebaseapp.com',
      measurementId: 'G-VTMPGJYM3L',
    });
  } catch (error) {
    logger.captureException(error);
    // eslint-disable-next-line no-empty
  }
}
